import React, { useState, useRef, useEffect, memo, Fragment } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState } from '@/app/store'
import styles from '@/styles/Home.module.scss'
import { time } from '@/lib/util'

const nowDate = () => {
  const date = new Date()
  return (
    date.getFullYear() +
    '年' +
    ('0' + (date.getMonth() + 1)).slice(-2) +
    '月' +
    ('0' + date.getDate()).slice(-2) +
    '日'
  )
}

const CampaignComponents = memo(() => {
  const data = nowDate()
  const dataCampain = useSelector(
    (campainState: RootState) => campainState.campain.campaign
  )

  return (
    <>
      <div className={styles.c_main_visual}>
        <img src={dataCampain.image} alt="" />
      </div>
      {/* テスト要素 */}
      {/* <p data-testid="testdata">{dataCampain.testdata}</p> */}
      <div className={styles.c_period_wrap}>
        {dataCampain.period ? (
          <p className={`text-sm ${styles.c_period}`}>
            開催期間: {time(dataCampain.campaignStartAt)} ~{' '}
            {time(dataCampain.campaignEndAt)}
          </p>
        ) : (
          <>
            {dataCampain.campaignStartAt > data ? (
              <p className={`text-sm ${styles.c_period}`}>
                {dataCampain.name}はイベント期間前です。
                <span className="block">
                  開催期間: {time(dataCampain.campaignStartAt)} ~{' '}
                  {time(dataCampain.campaignEndAt)}
                </span>
              </p>
            ) : (
              ''
            )}
            {dataCampain.campaignEndAt < data ? (
              <>
                <p className={`text-sm ${styles.c_period}`}>
                  {dataCampain.name}のイベントは終了しました。
                </p>
              </>
            ) : (
              ''
            )}
          </>
        )}
      </div>
      <section className="c-shadow_top bg-white py-6">
        <div className="l-inner">
          <h1 className="text-center text-h1 font-bold">{dataCampain.name}</h1>
          <p
            className="mt-2 text-sm"
            dangerouslySetInnerHTML={{
              __html: `${dataCampain.description}`,
            }}
          />
        </div>
      </section>
    </>
  )
})

CampaignComponents.displayName = 'CampaignComponents'

export default CampaignComponents
